module.exports = __webpack_public_path__ + "static/img/syicon_2.dbde3018.svg";